/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Returns an error which reports that no keys have been specified.
 * @docs-private
 */
export function getNoKeysSpecifiedError() {
  return Error('No keys have been specified.');
}
